import flatpickr from "flatpickr";
import { French } from 'flatpickr/dist/l10n/fr.js'
export default class DateInput{
    
    constructor(element) {
        this._wrapper = element;
        this._input = this._wrapper.querySelector('input')
        
        this.init();
    }
    
    init(){
        this.picker = flatpickr(this._input, {
            locale:French,
            dateFormat: "d-m-Y",
        });
    }
    
}